import React from 'react'

import { Button, Group } from '@mantine/core'
import { observer } from 'mobx-react-lite'
import { List } from 'react-window'

import {
  LISTING_MAX_HEIGHT,
  LISTING_MAX_HEIGHT_PX,
} from '#components/FolderExplorer/constants'
import { useMst } from '#state'
import { IFolder, IListing, IOrg } from '#state/types'
import { RowComponent } from '#types/react-window'

import { DocumentListing } from './DocumentListing'
import {
  isLoadMoreItem,
  RenderedListing,
  useFolderListings,
  useWorkspaceHistory,
} from './hooks'
import { FavoritesPlaceholder, RecentPlaceholder } from './Placeholder'

const DocListingRow: RowComponent<{
  data: RenderedListing[]
}> = (props) => {
  const item = props.data[props.index]

  return (
    <div style={props.style}>
      {isLoadMoreItem(item) ? (
        <Group justify="center" pt={10}>
          <Button
            size="xs"
            variant="subtle"
            onClick={item.onClick}
            loading={item.loading}
          >
            Load More
          </Button>
        </Group>
      ) : (
        <DocumentListing listing={item} />
      )}
    </div>
  )
}

const DocumentList = ({ documents }: { documents: RenderedListing[] }) => (
  <List
    rowCount={documents.length}
    rowHeight={LISTING_MAX_HEIGHT}
    rowComponent={DocListingRow}
    rowProps={{ data: documents }}
    overscanCount={20}
    style={{
      paddingTop: 5,
      paddingBottom: 5,
      '--doc-listing-max-height': LISTING_MAX_HEIGHT_PX,
    }}
  />
)

export const FavoritesList = ({ documents }: { documents: IListing[] }) => {
  if (documents.length === 0) {
    return <FavoritesPlaceholder />
  }
  return <DocumentList documents={documents} />
}

export const WorkspaceHistoryList = observer(function WorkspaceHistoryList({
  org,
}: {
  org: IOrg
}) {
  useWorkspaceHistory(org)
  const { recentListings: documents } = useMst()

  if (documents.length === 0) {
    return <RecentPlaceholder />
  }

  return <DocumentList documents={documents} />
})

export const FolderContentsList = observer(function FolderContentsList({
  folder,
}: {
  folder: IFolder
}) {
  const { renderedDocuments } = useFolderListings(folder)
  return <DocumentList documents={renderedDocuments} />
})
